import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sdc-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Initialize any additional logic if needed
  }

  navigateTo(route: string, category?: string): void {
    if (route === 'stockcount' && category) {
      this.router.navigate(['products/stockcount'], {
        state: { category }
      });
    } else {
      this.router.navigate([`products/${route}`]);
    }
  }
}